import { useQuery } from '@tanstack/react-query';
import { IRpCountResponse } from '@legacy/apis/types/resourcePlannerAPI';
import { getFetch } from '@legacy/utils/fetcher';
import { REFETCH_INTERVAL, RP_PROJECT_COUNT_KEY } from '../constants';

const RP_PROJECT_COUNT_URL_PATH =
  '/api/v2/resource-planner/rp-all-project-count';

const resourcePlannerFetch = (): Promise<IRpCountResponse> =>
  getFetch({ path: RP_PROJECT_COUNT_URL_PATH, key: RP_PROJECT_COUNT_KEY });

export const useGetRpProjectCount = (refetch: boolean) => {
  const { data, ...restProps } = useQuery({
    queryFn: resourcePlannerFetch,
    queryKey: [RP_PROJECT_COUNT_KEY],
    refetchInterval: refetch ? REFETCH_INTERVAL : undefined,
  });

  return {
    count: data?.model?.properties.count ?? 0,
    ...restProps,
  };
};
